import { useCallback } from 'react';
import { Stack } from '@mui/material';
import { NumberInput } from '@common/components/inputs';
import { UserPreferenceName } from '@modules/userPreferences';
import { useUserPreference, useUpdateUserPreferences } from '@/modules/userPreferences/hooks';
import { ZOOM_THRESHOLD_MAX, ZOOM_THRESHOLD_MIN } from '@/modules/lod/constants';
import { ResetUserPreferenceButton } from './ResetUserPreferenceButton';

type Props = {
  preference:
    | UserPreferenceName.LOD_TRACKS_ZOOM_THRESHOLD
    | UserPreferenceName.LOD_BOXES_ZOOM_THRESHOLD
    | UserPreferenceName.LOD_VEHICLE_LAYOUTS_ZOOM_THRESHOLD
    | UserPreferenceName.LOD_BUBBLES_ZOOM_THRESHOLD;
};

export const LodZoomInput = ({ preference }: Props) => {
  const value: number = useUserPreference(preference);
  const { updateUserPreference } = useUpdateUserPreferences();

  const onChange = useCallback(
    (next: number) => {
      if (next >= ZOOM_THRESHOLD_MIN && next <= ZOOM_THRESHOLD_MAX) {
        updateUserPreference(preference, next);
      }
    },
    [updateUserPreference, preference],
  );

  return (
    <Stack direction='row' alignItems='center' spacing={0.5}>
      <NumberInput
        sx={{ width: '100%' }}
        value={value}
        onChange={onChange}
        unit='%'
        minValue={ZOOM_THRESHOLD_MIN}
        disabled={false}
      />
      <ResetUserPreferenceButton preference={preference} />
    </Stack>
  );
};
